<div class="dx-field">
    <div class="dx-field-label w-50">{{ 'Produkte im Katalog anreichern' | translate }}</div>
    <dx-switch [value]="enrichProducts"
               (valueChange)="enrichProducts = $event">
    </dx-switch>
</div>
<div class="dx-field">
    <div class="dx-field-label w-50">{{ 'Produkte auf Webseite finden' | translate }}</div>
    <dx-switch [value]="findProducts"
               [disabled]="!hasValidUrl"
               (valueChange)="findProducts = $event">
    </dx-switch>
</div>
<div class="dx-field">
    <div class="dx-field-label w-50">{{ 'Webseite' | translate }}</div>
    <dx-text-box class="dx-field-value"
                 [value]="url"
                 (valueChange)="url = $event"
                 placeholder="https://example.com"
                 [inputAttr]="{ 'aria-label': 'URL' }">
        <dx-validator>
            <dxi-validator-validation-rule type="pattern"
                                           [pattern]="urlPattern"
                                           message="Bitte gültige Url eingeben">
            </dxi-validator-validation-rule>
        </dx-validator>
    </dx-text-box>
</div>